import sortBy from 'lodash-es/sortBy'

export function getEmailTableRowParticipants(email) {
  return email.outgoing ? email.recipients : [email.owner]
}

export function sortParticipantsMoreItems(items) {
  return sortBy(items, ['user.fullname'])
}
